import { BackgroundJobCard } from '@/report-app/pages/reporting/submissions/submit/backgroundJobCard'
import { submitReportProgress } from '@/enums/submitReportProgress'
import context from '@/context'
import React from 'react'

function GenerateXmlCard ({ submitProgress, reportInstanceGroupId, backgroundJobMetadata, onJobStarted }) {
  return <BackgroundJobCard dataCy='generateXmlCard'
    backgroundJobMetadata={backgroundJobMetadata}
    onJobStarted={onJobStarted}
    reportInstanceGroupId={reportInstanceGroupId}
    submitProgress={submitProgress}
    headerText='Reporting.GenerateXmlForSigning'
    beforeStartText='Reporting.GenerateXmlForSigning'
    bgJobSubmitProgress={submitReportProgress.enum.XmlGenerated}
    startCardSubmitProgress={submitReportProgress.enum.Validated}
    bgJobEndpoint={context.api.reportSubmissionGroupService.generateXmlForSigning} />
}

export { GenerateXmlCard }



// WEBPACK FOOTER //
// ./src/report-app/pages/reporting/submissions/submit/generateXmlCard.js